
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentful-preview/[slug]",
      function () {
        return require("private-next-pages/contentful-preview/[slug].page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentful-preview/[slug]"])
      });
    }
  